import type { FC } from 'react';
import { Input, Select } from 'antd';

interface BlogSeoPanelProps {
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string[];
  excerpt: string;
  onSeoTitleChange: (value: string) => void;
  onSeoDescriptionChange: (value: string) => void;
  onSeoKeywordsChange: (value: string[]) => void;
  onExcerptChange: (value: string) => void;
}

const BlogSeoPanel: FC<BlogSeoPanelProps> = ({
  seoTitle,
  seoDescription,
  seoKeywords,
  excerpt,
  onSeoTitleChange,
  onSeoDescriptionChange,
  onSeoKeywordsChange,
  onExcerptChange,
}) => (
  <div className="space-y-3 rounded-lg border border-slate-200 p-3 dark:border-slate-600">
    <p className="text-xs font-medium uppercase tracking-wider text-slate-500">Métadonnées SEO</p>
    <div>
      <label className="mb-1 block text-xs text-slate-500">SEO Title ({seoTitle.length}/60)</label>
      <Input value={seoTitle} onChange={(e) => onSeoTitleChange(e.target.value)} maxLength={70} placeholder="Titre SEO optimisé" />
    </div>
    <div>
      <label className="mb-1 block text-xs text-slate-500">SEO Description ({seoDescription.length}/155)</label>
      <Input.TextArea value={seoDescription} onChange={(e) => onSeoDescriptionChange(e.target.value)} maxLength={170} rows={2} placeholder="Meta description" />
    </div>
    <div>
      <label className="mb-1 block text-xs text-slate-500">Mots-clés</label>
      <Select mode="tags" value={seoKeywords} onChange={onSeoKeywordsChange} className="w-full" placeholder="Ajouter des mots-clés" />
    </div>
    <div>
      <label className="mb-1 block text-xs text-slate-500">Extrait</label>
      <Input.TextArea value={excerpt} onChange={(e) => onExcerptChange(e.target.value)} rows={2} placeholder="Résumé court de l'article" />
    </div>
  </div>
);

export default BlogSeoPanel;
